import {IDirective, IRootElementService} from "angular";
import {OrderDepthModel} from "../../models/OrderDepthModels";
import {OrderDepthVolumeChange} from "../../models/OrderDepthVolumeChange";

export const VolumeChange = "tfDepthVolumeChange";

export function volumeChange(): IDirective {
    return {
        restrict: "A",
        controllerAs: "ctrl",
        bindToController: {
            depth: "<tfDepthVolumeChange"
        },
        controller: DepthVolumeChangeDirectiveController,
        scope: {}
    };
}

const TargetClass = "depth-volume-change-target";
const ChangeUpClass = "volume-change-up";
const ChangeDownClass = "volume-change-down";

export class DepthVolumeChangeDirectiveController {

    /** @input */
    public set depth(model: OrderDepthModel | null) {
        if (model != null) {
            this.updateChangeClass(model);
        }
    }

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService) {
        this.$element.addClass(TargetClass);
        this.addAnimationListener();
    }

    private addAnimationListener() {
        this.$element[0].addEventListener("animationend", () => this.removeChangeClasses(), {passive: true});
    }

    private updateChangeClass(model: OrderDepthModel) {
        this.removeChangeClasses();
        if (model.change === OrderDepthVolumeChange.UP) {
            console.debug("Setting class to UP for", model);
            this.$element.addClass(ChangeUpClass);
        } else if (model.change === OrderDepthVolumeChange.DOWN) {
            console.debug("Setting class to DOWN for", model);
            this.$element.addClass(ChangeDownClass);
        }
    }

    private removeChangeClasses() {
        this.$element.removeClass(ChangeUpClass);
        this.$element.removeClass(ChangeDownClass);
    }
}
